import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import { useAdminData, useUser } from '../../../helpers/customHooks';
import { CrmOverviewTile, AdminNavTile } from './CrmOverviewTile';
import { StyledList } from '../../../styles/templates/Projects';
import PageHeader from '../../../styles/templates/PageHeader';
import { RouterPaths } from '../../../constants/routes';
import { selectAdminCounts } from '../../../redux/selectors/adminProjects';

import ReviewQueueIcon from '../../../assets/icons/ReviewQueueIcon';
import CommunityIcon from '../../../assets/icons/Community';
import RocketIcon from '../../../assets/icons/Rocket';
import { USER_ROLES } from '../../../constants/roles';

type Props = {
  userRole: USER_ROLES;
};

const CrmOverviewPage: React.FC<Props> = ({ userRole }) => {
  const history = useHistory();
  const user = useUser();
  const [_, users] = useAdminData();
  const [reviewCount, productionCount] = useSelector(selectAdminCounts);

  const isAdmin = userRole === USER_ROLES.ADMIN;

  return (
    <>
      <PageHeader title={`Hello ${user?.username}`} subtitle="Welcome to your Admin Portal" />

      <StyledList>
        <CrmOverviewTile title="Apps in Review" number={reviewCount} Icon={ReviewQueueIcon} />
        {isAdmin && (
          <CrmOverviewTile title="Registered Users" number={users.length} Icon={CommunityIcon} />
        )}
        <CrmOverviewTile title="Apps in Production" number={productionCount} Icon={RocketIcon} />
      </StyledList>

      <StyledList>
        {isAdmin && (
          <AdminNavTile
            title="Developers"
            onClick={() => history.push(RouterPaths.adminDevelopers)}
          />
        )}
        <AdminNavTile
          title="Projects"
          onClick={() =>
            history.push(isAdmin ? RouterPaths.adminProjects : RouterPaths.managerProjects)
          }
        />
        <AdminNavTile
          title="Review Queue"
          onClick={() =>
            history.push(isAdmin ? RouterPaths.adminReview : RouterPaths.managerReview)
          }
        />
      </StyledList>
    </>
  );
};

export default CrmOverviewPage;
